import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import * as actions from './actions';
import { getIndex } from '@state/utils/helper';
import { IndexType } from '@fnModels/algolia/algolia';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type MortgageBrokerageSearchStateModel = AlgoliaBaseState<unknown>;
@State<MortgageBrokerageSearchStateModel>({
	name: 'mortgageBrokerageSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class MortgageBrokeragesSearchState extends AlgoliaSearchState<MortgageBrokerageSearchStateModel> {
	protected indexName = getIndex(IndexType.MORTGAGE_BROKERAGES);

	@Selector([MortgageBrokeragesSearchState])
	static getList(state: MortgageBrokerageSearchStateModel): unknown[] {
		return state?.items;
	}

	@Selector([MortgageBrokeragesSearchState])
	static getSearching(state: MortgageBrokerageSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<MortgageBrokerageSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
